export const MANUAL = {
  value: "MANUAL",
  key: "members.followUps.origin.manual",
};
export const PHONE = {
  value: "PHONE",
  key: "members.followUps.origin.phone",
};
export const EMAIL = {
  value: "EMAIL",
  key: "members.followUps.origin.email",
};
export const SYSTEM = {
  value: "SYSTEM",
  key: "members.followUps.origin.system",
};

export default [MANUAL, PHONE, EMAIL, SYSTEM];

export const ENUM_DICT = {
  MANUAL,
  PHONE,
  EMAIL,
  SYSTEM,
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/enums/followUpOriginTypes.js